var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOffice(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6537_281739)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2C8 0.89543 8.89543 0 10 0H14C15.1046 0 16 0.895431 16 2V3H22C23.1046 3 24 3.89543 24 5V11C24 12.0144 23.6224 12.9407 23 13.6458V22C23 23.1046 22.1046 24 21 24H3C1.89543 24 1 23.1046 1 22V13.6458C0.377637 12.9407 0 12.0144 0 11V5C0 3.89543 0.895431 3 2 3H8V2ZM2 5V11C2 12.1046 2.89543 13 4 13H20C21.1046 13 22 12.1046 22 11V5H2ZM3 15V22H21V15H3ZM14 2H10V3H14V2Z",
    fill: "#165297"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 12C8.55228 12 9 12.4477 9 13V15C9 15.5523 8.55228 16 8 16C7.44772 16 7 15.5523 7 15V13C7 12.4477 7.44772 12 8 12ZM16 12C16.5523 12 17 12.4477 17 13V15C17 15.5523 16.5523 16 16 16C15.4477 16 15 15.5523 15 15V13C15 12.4477 15.4477 12 16 12Z",
    fill: "#7397C1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6537_281739"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffice);
export default __webpack_public_path__ + "static/media/office.b3b6df14635aee253a9edd39db902727.svg";
export { ForwardRef as ReactComponent };